import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import $ from 'jquery';
import Slider from "react-slick";
import {number_format,number_input_format} from '../helper/format';
import {
  isMobile
} from "react-device-detect";

export default class Modeldetailpopup extends Component {
  constructor(props)
  {
    super(props);
    this.state = {
      open : false,
      showDetail: false
    }
    this.currentIndex = 0;
    this.colors = null;
    this.customStyle = {
      maxWidth : '300px'
    };
  }
  Open()
  {
    this.setState({
      open: true
    });
  }
  Close()
  {
    this.setState({
      open: false
    });
  }
  getName()
  {
      return window.encodeURI(this.colors[this.currentIndex].name);
  }
  generateKey()
  {
      return (new Date().getTime()) +  Math.random() * (100 - 0) + 0;
  }
  render()
  {
    const self = this;
    const model = this.props.select_model;
    if( model ) {
        let infos = JSON.parse(model.info);
        let colors = JSON.parse(model.color), availColors = [];
        for ( let i = 0 ; i < colors.length ; i++)
        {
            if( !colors[i].available )
            {
                availColors.push(colors[i]);
            } else {
                if( colors[i].available == 1 )
                {
                    availColors.push(colors[i]);
                }
            }
        }
        colors = availColors;
        this.colors = availColors;
      let settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        afterChange: current => {
          this.currentIndex = current;
        },
        customPaging: function(i) {
          return (
            <a style={{'backgroundColor':'#' + colors[i].hex ,'width':'20px','height':'20px','display':'inline-block'}}>

            </a>);
        }
      }
    return (
        <Modal open={this.state.open} onClose={()=>{self.Close()}} center >
          <div className="modal-dialog" style={this.customStyle} >
            <div>
              <Slider {...settings}>
                {colors.map(color=>{
                  return (
                    <div key={color.hex} className="img-phoneres">
                      <img className={'img-responsive ' } src={"https://api.tfamily.co.kr/uploads/device/"+self.props.select_model_idx+"_"+color.hex+".jpg"} />
                    </div>
                  )
                })}
              </Slider>
              <div className="modelPopupTitle text-center">
                <h4>{model.name}</h4>
                <div>
                  <a onClick={()=>{self.setState({
                    showDetail : true
                  })}} className="btn btn-default">상세보기</a>&nbsp;
                  <a onClick={()=>{self.props.onModelSelect()}} className="btn btn-default">선택</a>
                </div>
              </div>

              <div className={(!this.state.showDetail) ? 'hide' : ''}>
              <table className="table modeldetail mt20">
                <tbody>
                { infos.map(info=>{
                  return(<tr key={'info'+ this.generateKey()}>
                    <td style={ {width : '100px', color: 'gray', fontWeight: 'bold' } }>
                      {info.field}
                    </td>
                    <td style= { {fontWeight:'bold'} }>
                      {info.value}
                    </td>
                  </tr>)
                })}
                </tbody>
              </table>
              </div>

            </div>
          </div>
        </Modal>
    )} else {
      return (<div></div>);
    }
  }
}
